module.exports = function(done, value){
  return {value: value, done: !!done};
};


//////////////////
// WEBPACK FOOTER
// ../~/.2.4.1@core-js/library/modules/_iter-step.js
// module id = 63
// module chunks = 0